var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "jackpot-popups" },
    [
      _c(
        "transition",
        { attrs: { name: "jackpot-popups-pop" } },
        [
          _vm.isCollectionOpen
            ? _c(
                "Popup",
                _vm._b(
                  {
                    attrs: {
                      active: true,
                      animation: "fade",
                      transparentBg: false,
                      fullsize: false,
                      hasBg: false,
                      align: "right",
                      borderRadiusBySide: ["16px", "16px", "16px", "16px"],
                    },
                    on: {
                      close: function ($event) {
                        _vm.isCollectionOpen = false
                      },
                    },
                  },
                  "Popup",
                  { modalContainerStyles: _vm.collectionContainerStyle },
                  false
                ),
                [
                  _c("JackPotCollectionPopup", {
                    on: { jackpotPopup: _vm.collectTickets },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "transition",
        { attrs: { name: "jackpot-popups-slide" } },
        [
          _vm.isJackpotPopupOpen
            ? _c(
                "Popup",
                _vm._b(
                  {
                    attrs: {
                      active: true,
                      animation: "fade",
                      transparentBg: false,
                      fullsize: false,
                      align: "right",
                      valign: "bottom",
                      hasBg: false,
                      showHeader: true,
                      borderRadiusBySide: ["16px", "0", "0", "16px"],
                    },
                    on: { close: _vm.close },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "modalHeader",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "jackpot-popups__header" },
                                [
                                  _c(
                                    "Nav",
                                    {
                                      attrs: {
                                        imageURL: _vm.activePopupPage,
                                        toURL: _vm.toURL,
                                        popupLevel: _vm.popupLevel,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t(_vm.activePopupPage)) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _vm.activePopupPage === _vm.PopupPage.jackpot
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "jackpot-popups__nav-btns",
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: require("@/assets/images/jackpot-history.svg"),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.showPage(
                                                  _vm.PopupPage.jackpotHistory
                                                )
                                              },
                                            },
                                          }),
                                          _vm.config.enableJackpot
                                            ? _c("img", {
                                                attrs: {
                                                  src: require("@/assets/images/jackpot-instant-prize.svg"),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.showPage(
                                                      _vm.PopupPage.jackpotHelp
                                                    )
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "jackpot-popups__close",
                                      on: { click: _vm.close },
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/images/close.webp"),
                                        },
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      1694495980
                    ),
                  },
                  "Popup",
                  { modalContainerStyles: _vm.drawerContainerStyle },
                  false
                ),
                [
                  _vm.activePopupPage === _vm.PopupPage.jackpot
                    ? _c("JackPotPopup")
                    : _vm._e(),
                  _vm.activePopupPage === _vm.PopupPage.jackpotHistory
                    ? _c("JackpotLogs", {
                        attrs: {
                          logTickets: _vm.payoutTicketsLog,
                          ticketsLength: _vm.ownerTicketsLog.length || 0,
                          hasHeader: "",
                        },
                        on: { loadMoreTickets: _vm.getOwnerTicketsLog },
                      })
                    : _vm._e(),
                  _vm.activePopupPage === _vm.PopupPage.jackpotHelp
                    ? _c("HelpContent", {
                        attrs: { helpSource: _vm.instantPrizeHelpGuide },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }